module.exports = __webpack_public_path__ + "assets/img/ic-trash-hover.4732a271.svg";